import { EngagementActions, Loader, ModalParts, ScreenShotHeader } from 'BreetComponents';
import {
	alwaysRefetchApiQueryOptions,
	isConversions,
	isEdits,
	isWithdrawals,
	type ITransactionHistory,
	type ITransactionHistoryConversionsDoc,
	type ITransactionHistoryEditsDoc,
	type ITransactionHistoryWithdrawalsDoc,
} from 'BreetHelpers';
import { closeModal, selectModals, useAppDispatch, useAppSelector, useGetTransactionEditServicesByIdQuery } from 'BreetRedux';
import { useCallback } from 'react';

import Conversions from './components/Conversions';
import Edits from './components/Edits';
import Withdrawals from './components/Withdrawals';

const DialogWithdrawalHistoryDetails = () => {
	const modals = useAppSelector(selectModals);

	const dispatch = useAppDispatch();

	const modalMetaData = modals.find((i) => i.id === 'withdrawalHistoryDetails')?.metadata as { id: string } | undefined;

	const { isLoading, data: withdrawalHistoryData } = useGetTransactionEditServicesByIdQuery(modalMetaData?.id ?? '', {
		skip: !modalMetaData?.id,
		...alwaysRefetchApiQueryOptions,
	});

	const withdrawalHistory = withdrawalHistoryData?.data;

	const exitModal = useCallback(() => {
		dispatch(closeModal('withdrawalHistoryDetails'));
	}, [dispatch]);

	if (isLoading) return <Loader />;

	return (
		<ModalParts.Wrapper
			title='Withdrawal Details'
			rightSheet
			handleBackLink={exitModal}
		>
			<div className='transactiondetails'>
				<div
					className='transactiondetails_content scrollbar'
					id='withdrawal-history-detail'
				>
					<ScreenShotHeader title='Withdrawal Details' />

					{isWithdrawals(withdrawalHistory) && (
						<Withdrawals withdrawalHistoryData={withdrawalHistory as ITransactionHistory<ITransactionHistoryWithdrawalsDoc>} />
					)}

					{isEdits(withdrawalHistory) && (
						<Edits withdrawalHistoryData={withdrawalHistory as ITransactionHistory<ITransactionHistoryEditsDoc>} />
					)}

					{isConversions(withdrawalHistory) && (
						<Conversions withdrawalHistoryData={withdrawalHistory as ITransactionHistory<ITransactionHistoryConversionsDoc>} />
					)}
				</div>

				<EngagementActions
					shareContentDetails={{
						text: 'Transaction Snapshot',
						title: 'Withdrawal Receipt',
						url: 'https://breet.io',
						screenshotElementId: 'withdrawal-history-detail',
						action: 'share',
					}}
				/>
			</div>
		</ModalParts.Wrapper>
	);
};

export default DialogWithdrawalHistoryDetails;
